const getProjectsItems = state => state.projects.items;

const projectsSelectors = {
  getProjectsItems,
};

export default projectsSelectors;
